/* global axios */
import ApiClient from './ApiClient';

class ProductivityReportsAPI extends ApiClient {
  constructor() {
    super('productivity_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getSummary({ from, to, agentIds, inboxIds, teamIds, businessHours }) {
    return axios.get(this.url, {
      params: {
        since: from,
        until: to,
        agent_ids: agentIds,
        inbox_ids: inboxIds,
        team_ids: teamIds,
        business_hours: businessHours,
      },
    });
  }

  getTopContacts({ from, to, agentIds, inboxIds, teamIds, businessHours }) {
    return axios.get(`${this.url}/top_contacts`, {
      params: {
        since: from,
        until: to,
        agent_ids: agentIds,
        inbox_ids: inboxIds,
        team_ids: teamIds,
        business_hours: businessHours,
      },
    });
  }

  getExport({ from, to, agentIds, inboxIds, teamIds, businessHours }) {
    return axios.get(`${this.url}/export`, {
      params: {
        since: from,
        until: to,
        agent_ids: agentIds,
        inbox_ids: inboxIds,
        team_ids: teamIds,
        business_hours: businessHours,
      },
    });
  }
}

export default new ProductivityReportsAPI();
